/**
 * Application Configuration
 * 
 * This file centralizes all environment variables and configuration settings.
 * All environment variables must be prefixed with REACT_APP_ to be accessible in the browser.
 */

const config = {
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.afriqcm.com',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  },

  // Application Configuration
  app: {
    name: process.env.REACT_APP_APP_NAME || 'Afriq-NW',
    version: process.env.REACT_APP_APP_VERSION || '2.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  },

  // Authentication Configuration
  auth: {
    tokenKey: process.env.REACT_APP_AUTH_TOKEN_KEY || 'afriq_nw_auth_token',
    refreshTokenKey: process.env.REACT_APP_REFRESH_TOKEN_KEY || 'afriq_nw_refresh_token',
  },

  // Feature Flags
  features: {
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    debugMode: process.env.REACT_APP_ENABLE_DEBUG_MODE === 'true',
  },

  // Other Configuration
  pagination: {
    pageSize: parseInt(process.env.REACT_APP_PAGE_SIZE || '10', 10),
  },

  upload: {
    maxFileSize: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '5242880', 10), // 5MB in bytes
  },

  // User Roles Configuration
  roles: {
    admin: 'admin',
    blogger: 'blogger',
    centerAdmin: 'center_admin',
  },

  // Helper function to check if we're in development
  isDevelopment: () => config.app.environment === 'development',
  
  // Helper function to check if we're in production
  isProduction: () => config.app.environment === 'production',
};

export default config;

